<template>
  <div>
    <v-container
      v-if="!contentPage"
      class="fill-height"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
        >
          Cargando...
          <v-icon>
            mdi-timer-sand-empty mdi-spin
          </v-icon>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="viewPage">
      <v-row>
        <v-col
          cols="12"
        >
          <v-tabs
            ref="tab"
            v-model="tabs"
            color="primary accent-4"
            right
            :grow="true"
            multiple
          >
            <v-tab :popout="true">
              Grupos
            </v-tab>
            <v-tab>Estudiantes</v-tab>
            <v-tab v-if="typeUser === 'tutor'">
              Asignados
            </v-tab>
          </v-tabs>
          <v-tabs-items
            v-model="tabs"
            class="mt-4"
          >
            <v-tab-item>
              <v-expansion-panels dark>
                <v-expansion-panel
                  v-for="(group, index) in groups"
                  :key="index"
                  class="mt-2 light-blue darken-4"
                >
                  <v-expansion-panel-header>
                    <div>
                      {{ group.name }}
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-container
                      class="fill-height"
                      fluid
                    >
                      <v-row
                        align="start"
                        justify="start"
                      >
                        <v-col
                          cols="12"
                          sm="4"
                        >
                          <h3>Estudiantes</h3>
                          <p>Cantidad: {{ group.students.length }}</p>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-row>
                            <v-col>
                              <group-statistics
                                :disabled-btn="group.students.length < 1"
                                :details-group="group"
                              />
                            </v-col>
                            <v-col>
                              <v-btn
                                class="ma-2"
                                outlined
                                color="primary"
                                block
                                @click="detailsGroup(group.name)"
                              >
                                Lista de Estudiantes
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-speed-dial
                          v-model="fab"
                          bottom
                          right
                          absolute
                          direction="left"
                          transition="slide-y-reverse-transition"
                          :open-on-hover="true"
                        >
                          <template v-slot:activator>
                            <v-btn
                              v-model="fab"
                              color="grey darken-2"
                              dark
                              fab
                            >
                              <v-icon v-if="fab">
                                mdi-close
                              </v-icon>
                              <v-icon
                                v-else
                                large
                              >
                                mdi-account-group-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                fab
                                dark
                                small
                                color="success"
                                v-bind="attrs"
                                v-on="on"
                                @click="dialogGroup('edit', group.name)"
                              >
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Editar grupo</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                fab
                                dark
                                small
                                color="red"
                                v-bind="attrs"
                                v-on="on"
                                @click="dialogGroup('del', group.name)"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Eliminar Grupo</span>
                          </v-tooltip>
                        </v-speed-dial>
                      </v-row>
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-tab-item>
            <v-tab-item>
              <students-tutor v-if="typeUser === 'tutor'" />
              <students-parent v-else />
            </v-tab-item>
            <v-tab-item>
              <students-assingned-tutor />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
        <v-col
          cols="12"
          md="10"
        />
      </v-row>
      <help-button
        v-if="tabs < 3"
        :tutorial="tutorial"
      />
      <dialog-create-group v-if="tabs === 0" />
      <invite-student
        v-if="tabs === 1"
        :item="{}"
        :invitation-type="invitationType"
      />
      <v-dialog
        v-model="dialogOptionGroup"
        max-width="490"
      >
        <v-card>
          <v-form
            ref="form1"
          >
            <div v-if="optionGroup === 'edit'">
              <v-card-title
                class="headline text-left mb-4"
              >
                Editar Grupo
              </v-card-title>

              <v-card-text>
                <p>
                  Cambia el nombre del grupo ({{ nameGroup }})
                </p>
                <v-row
                  justify="center"
                >
                  <v-col
                    cols="12"
                    sm="8"
                    md="6"
                  >
                    <v-text-field
                      v-model="newName"
                      label="Nombre del Grupo"
                      prepend-icon="mdi-account-multiple-plus-outline"
                      :rules="groupNameRules"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
            <div v-if="optionGroup === 'add'">
              <v-card-title
                class="headline text-left mb-4"
              >
                Agregar Estudiante
              </v-card-title>

              <v-card-text>
                <p>
                  Selecciona el estudiante que desea agregar al grupo
                </p>
                <v-row
                  justify="center"
                >
                  <v-col
                    cols="12"
                    sm="8"
                    md="6"
                  >
                    <v-select
                      v-model="studentSelect"
                      :items="students"
                      item-text="name"
                      item-value="actions.id"
                      label="Estudiante"
                      :rules="studentsRules"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
            <div v-if="optionGroup === 'del'">
              <v-card-title

                class="headline text-left mb-4"
              >
                Eliminar Grupo
              </v-card-title>
              <v-card-text>
                <p>
                  ¿Está seguro de que quiere eliminar el grupo: <strong> {{ nameGroup }} </strong>?
                </p>
              </v-card-text>
            </div>

            <v-card-actions>
              <v-spacer />

              <v-btn
                color="green darken-1"
                text
                @click="close"
              >
                Cancelar
              </v-btn>

              <v-btn
                v-if="optionGroup === 'edit'"
                color="green darken-1"
                text
                @click="changeGroupName"
              >
                Actualizar
              </v-btn>
              <v-btn
                v-if="optionGroup === 'add'"
                color="green darken-1"
                text
                @click="addStudentsGroup"
              >
                Agregar
              </v-btn>
              <v-btn
                v-if="optionGroup === 'del'"
                color="green darken-1"
                text
                @click="deleteGroup"
              >
                Eliminar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <details-group
        :view="dialogDetailsGroup"
        @update="updateDialogDetailsGroup"
        @updateDetailsGroup="detailsGroup"
        @dialogGroup="dialogGroup"
      />
    </v-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import DialogCreateGroup from '@/views/dashboard/pages/panel/DialogCreateGroup'
  import StudentsTutor from '@/views/dashboard/pages/panel/StudentsTutor'
  import StudentsParent from '@/views/dashboard/pages/panel/StudentsParent'
  import StudentsAssingnedTutor from '@/views/dashboard/pages/panel/StudentsAssingnedTutor'
  import DetailsGroup from '@/views/dashboard/pages/panel/DetailsGroup'
  import HelpButton from '@/views/dashboard/pages/panel/HelpButton'
  import InviteStudent from '@/views/dashboard/invitations/InviteStudent'
  import GroupStatistics from '@/views/dashboard/pages/panel/GroupStatistics'

  export default {
    components: {
      DialogCreateGroup,
      StudentsTutor,
      StudentsParent,
      StudentsAssingnedTutor,
      DetailsGroup,
      HelpButton,
      InviteStudent,
      GroupStatistics,
    },
    data () {
      return {
        viewPage: false,
        contentPage: false,
        invitationType: 'byStudent',
        dialogDetailsGroup: false,
        dataGroup: {},
        tabs: [0],
        fab: false,
        optionGroup: null,
        dialogOptionGroup: false,
        nameGroup: '',
        newName: '',
        studentSelect: '',
        groupNameRules: [
          v => !!v || 'Nombre de grupo es requerido',
          v => !this.groupNameExist || 'El nombre del grupo ya existe',
        ],
        studentsRules: [v => !!v || 'Estudiante es requerido'],
        indexGroup: -1,
      }
    },
    computed: {
      ...mapState(['userData', 'user']),
      groups () {
        return this.userData.groups
      },
      students () {

          let allStudents = this.userData.students.concat(this.userData.studentsAssigned);

          let studentsInGroup =  this.groups[this.indexGroup].students;

          let sorted = allStudents.filter(st => !studentsInGroup.includes(st.actions.id));

          return sorted;//.sort( (a,b ) => a.lastname < b.lastname );

      },
      groupNameExist () {
        return this.groups.filter(g => g.name !== this.nameGroup).map(p => p.name).includes(this.newName)
      },
      typeUser () {
        return this.userData.type
      },
      tutorial () {
        switch(this.tabs)
        {
          case 0:
            return this.typeUser === 'parent' ? 'tuto-parent-students-groups' : 'tuto-teacher-students-groups'
          case 1:
            return this.typeUser === 'parent' ? 'parent-players-all' : 'tutor-players-all'
          case 2:
            return 'teacher-assigned'
        }
        return ''
      },
    },
    watch: {
      dataGroup (val) {
        this.$store.commit('SET_DATA_GROUP', val)
      },
    },
    updated: function () {
      var ref = this
      this.$nextTick(function () {
        if (typeof ref.$refs.tab !== 'undefined') {
          this.contentPage = true
        }
      })
    },
    methods: {
      close () {
        this.$refs.form1.reset()
        this.dialogOptionGroup = false
        this.nameGroup = ''
        this.newName = ''
        this.studentSelect = ''
      },
      dialogGroup (val, groupName) {
        this.indexGroup = this.groups.map(e => e.name).indexOf(groupName)
        this.optionGroup = val
        this.nameGroup = groupName
        this.newName = groupName
        this.dialogOptionGroup = true
      },
      changeGroupName () {
        if (this.$refs.form1.validate()) {
          const group = this.groups[this.indexGroup]
          group.name = this.newName
          this.$store.dispatch('EDIT_GROUP', this.groups)
          this.close()
        } else {
          console.log('Faltan datos')
        }
      },
      addStudentsGroup () {
        if (this.$refs.form1.validate()) {
          const groups = this.groups
          const group = groups[this.indexGroup]
          group.students.push(this.studentSelect)
          this.detailsGroup(this.nameGroup)

          console.log("Student added: "+ this.studentSelect.name);

          this.$store.dispatch('EDIT_GROUP', groups)
          this.close()
        } else {
          console.log('Faltan datos')
        }
      },
      deleteGroup () {
        this.groups.splice(this.indexGroup, 1)
        this.$store.dispatch('EDIT_GROUP', this.groups)
        this.close()
      },
      async detailsGroup (groupName) {
        this.indexGroup = this.groups.map(e => e.name).indexOf(groupName)
        this.dataGroup = await this.$store.dispatch('GET_STUDENTS_BY_GROUP', this.indexGroup)
        this.dialogDetailsGroup = true
      },
      updateDialogDetailsGroup (newData) {
        this.dialogDetailsGroup = newData
      },
    },
    beforeRouteEnter (to, from, next) {
      next(async vm => {
        const userData = await vm.$store.dispatch('GET_USER_DATA')
        if (userData.type === 'tutor' || userData.type === 'parent') {
          vm.viewPage = true
          // next({
          //   name: '/panel/store',
          // })
        } else {
          console.log('Está intentando ingresar a una pagina no autorizada.')
          next({
            name: 'Home',
          })
        }
      })
    },
  }
</script>
